<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
 <el-container>
      <el-container>
     <el-aside  width="180px"  v-if="formParameter.img">        
               <el-image :src="formParameter.img" width="175px"></el-image>
               {{formParameter.name}}
      </el-aside>

  <el-main>
    <el-form
        class="dataForm"
        ref="form"
        :disabled="false"
        :model="formParameter"
        :inline="true"
        label-width="78px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="籍贯" prop="jiguan"
              ><el-input
                :readonly="read"
                v-model="formParameter.jiguan"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" prop="sex"
              > 
                 {{formParameter.sex==1?"男":"女"  }}
             
            </el-form-item> </el-col>
            <el-col :span="8">
            <el-form-item label="身份证" prop="idno"
              ><el-input
                :readonly="read"
                v-model="formParameter.idno"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="毕业学校" prop="school">
              <el-input
                :readonly="read"
                v-model="formParameter.school"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学历" prop="xueli">
              <el-input
                :readonly="read"
                v-model="formParameter.xueli"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="专业" prop="subject"
              ><el-input
                :readonly="read"
                v-model="formParameter.subject"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        
        </el-row>
        <el-row>
        <el-col :span="8">
            <el-form-item label="毕业时间" prop="gradedate">
              <el-input
                :readonly="read"
                v-model="formParameter.gradedate"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报名时间" prop="bmtm">
              <el-input
                :readonly="read"
                v-model="formParameter.bmtm"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="缴费时间" prop="jftm">
              <el-input
                :readonly="read"
                v-model="formParameter.jftm?formParameter.jftm:formParameter.bmtm"
                autocomplete="off"
              ></el-input>
            </el-form-item>
       </el-col>
        </el-row>      
        <el-row  v-if="trNoshow()"> 
             <el-col :span="6">
            <el-form-item label="交费方式" prop="bmffs">
              <el-input
                :readonly="read"
                v-model="formParameter.bmffs"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>   
          <el-col :span="6">
            <el-form-item label="扣保证金" prop="bzj">
              <el-input
                :readonly="read"
                v-model="formParameter.bzj"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="补贴" prop="btcost">
              <el-input
                :readonly="read"
                :value="formParameter.btcost"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
         <el-col :span="6">
            <el-form-item label="学费金额" prop="costs"
              ><el-input
                :readonly="read"
                v-model="formParameter.costs"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>         
        </el-row>
       <el-row>   
        <el-col :span="8">
            <el-form-item  v-if="trNoshow()" label="实收金额" prop="paied">
              <el-input
                :readonly="read"
                v-model="formParameter.paied"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        
         <el-col :span="8">
            <el-form-item label="渠道平台" prop="dbColumn_recruid"
              ><el-input
                :readonly="read"
                v-model="formParameter.dbColumn_recruid"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>   
           <el-col :span="8">
            <el-form-item label="招生类型" prop="type"
              ><el-input
                :readonly="read"
                v-model="formParameter.type"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
     </el-row>
       <el-row>
           <el-col :span="8">
            <el-form-item label="报读课程" prop="post">
              <el-input
                :readonly="read"
                v-model="formParameter.post"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item   label="咨询评价" prop="pjtxt3"
              ><el-input  v-if="pj0"
                :readonly="read"
                v-model="pj0.usrid"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="沟通能力" prop="pjtxt1">
               <el-input v-if="pj0"
                :readonly="read"
                v-model="pj0.pjtxt1"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
          <el-form-item label="智力评价" prop="pjtxt2">
               <el-input v-if="pj0"
                :readonly="read"
                v-model="pj0.pjtxt2"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" >
            <el-form-item label="情商评价" prop="pjtxt3"
              ><el-input v-if="pj0"
                  :readonly="read"
                v-model="pj0.pjtxt3"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          
        
        </el-row>
      
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark"
              ><el-input
                type="textarea"
                rows="4"
                v-model="formParameter.remark"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
      </el-form>
  </el-main>
</el-container>
     <el-footer> 
           <el-row>
          <el-col :span="24"  v-if="formParameter.kcsqb">
            <el-image :src="formParameter.kcsqb"></el-image></el-col>
                     </el-row>  <el-row>
          <el-col :span="24"  v-if="formParameter.jianli">
            <el-image :src="formParameter.jianli"></el-image>
          </el-col>
               </el-row>
               </el-footer>
      </el-container>
    </div>
    <div slot="footer">
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/stu/stu.js";
export default {
  name: "show",
  components: {
    popup,
  },
  data() {
    return {
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      isShow: 0,
      read: true,
      pj0: {},
      pj1: false,
      me:{}
    };
  },
  methods: {
    trNoshow() {
      // 老师或教学总监 -技术跟进
      if ('tr' == this.me.role || 'mgr2' == this.me.role2) {
        return false
      } else { 
        return true
      }
    },
    //打开弹框
    open(parameter, me, title) {

      this.parameter = parameter;
      console.log( this.parameter)
      this.me = me;
      this.$refs.popup.open(title, "75%");
      this.$nextTick(() => {
        this.init();
      });
   
    },
    //关闭弹框
    close() {
      this.$refs.popup.close();
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();
 
        //查询数据
        let parameter = {
          stuid: this.parameter.id
        };
        api.getOne(parameter, (response) => {
          console.log(response)
          this.formParameter = response.data.stu;
      
          this.formParameter.btcost =  ( this.parameter.btcost? this.parameter.btcost:0)  ;
          this.formParameter.realCost = this.parameter.costs -this.formParameter.btcost -( this.formParameter.bzj? this.formParameter.bzj:0)  ;
          
          let pjs = response.data.pj;
          if (pjs) {
            if (pjs.length == 1) {
              this.pj0 = pjs[0];
            } else {
              if (pjs[0] && pjs[0].pjname3 == "情商评价") {
                this.pj0 = pjs[0];
                this.pj1 = pjs[1];
              } else {
                this.pj1 = pjs[0];
                this.pj0 = pjs[1];
              }
            }
          }
          this.popupLoading = false;
        });
 
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 80px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height:10px;
}
 .el-footer {
    background-color: #e9eef3;
    color: #333;
    text-align: center;
    line-height: 1px;
  } 
</style>
